export const cityCodes = [
  // United States - Major Cities
  { code: 'NYC', city: 'New York', country: 'USA' },
  { code: 'LAX', city: 'Los Angeles', country: 'USA' },
  { code: 'CHI', city: 'Chicago', country: 'USA' },
  { code: 'MIA', city: 'Miami', country: 'USA' },
  { code: 'LAS', city: 'Las Vegas', country: 'USA' },
  { code: 'SFO', city: 'San Francisco', country: 'USA' },
  { code: 'BOS', city: 'Boston', country: 'USA' },
  { code: 'SEA', city: 'Seattle', country: 'USA' },
  { code: 'WAS', city: 'Washington D.C.', country: 'USA' },
  { code: 'ATL', city: 'Atlanta', country: 'USA' },
  { code: 'DEN', city: 'Denver', country: 'USA' },
  { code: 'PHX', city: 'Phoenix', country: 'USA' },
  { code: 'HOU', city: 'Houston', country: 'USA' },
  { code: 'DAL', city: 'Dallas', country: 'USA' },
  { code: 'ORL', city: 'Orlando', country: 'USA' },
  { code: 'SDQ', city: 'San Diego', country: 'USA' },
  { code: 'MSP', city: 'Minneapolis', country: 'USA' },
  { code: 'DTT', city: 'Detroit', country: 'USA' },
  { code: 'PHL', city: 'Philadelphia', country: 'USA' },
  { code: 'PDX', city: 'Portland', country: 'USA' },
  { code: 'SLC', city: 'Salt Lake City', country: 'USA' },
  { code: 'CHA', city: 'Charlotte', country: 'USA' },
  { code: 'AUS', city: 'Austin', country: 'USA' },
  { code: 'NAS', city: 'Nashville', country: 'USA' },
  { code: 'SAT', city: 'San Antonio', country: 'USA' },
  { code: 'TAM', city: 'Tampa', country: 'USA' },
  { code: 'STL', city: 'St. Louis', country: 'USA' },
  { code: 'PIT', city: 'Pittsburgh', country: 'USA' },
  { code: 'CIN', city: 'Cincinnati', country: 'USA' },
  { code: 'MKE', city: 'Milwaukee', country: 'USA' },
  { code: 'CLE', city: 'Cleveland', country: 'USA' },
  { code: 'KC', city: 'Kansas City', country: 'USA' },
  { code: 'IND', city: 'Indianapolis', country: 'USA' },
  { code: 'CMH', city: 'Columbus', country: 'USA' },
  { code: 'RNO', city: 'Reno', country: 'USA' },
  { code: 'ABQ', city: 'Albuquerque', country: 'USA' },
  { code: 'TUS', city: 'Tucson', country: 'USA' },
  { code: 'ELP', city: 'El Paso', country: 'USA' },
  { code: 'OKC', city: 'Oklahoma City', country: 'USA' },
  { code: 'MEM', city: 'Memphis', country: 'USA' },
  { code: 'JAX', city: 'Jacksonville', country: 'USA' },
  { code: 'RIC', city: 'Richmond', country: 'USA' },
  { code: 'BUF', city: 'Buffalo', country: 'USA' },
  { code: 'ROC', city: 'Rochester', country: 'USA' },
  { code: 'ANC', city: 'Anchorage', country: 'USA' },
  { code: 'HNL', city: 'Honolulu', country: 'USA' },
  { code: 'OGG', city: 'Maui', country: 'USA' },

  // Canada
  { code: 'YTO', city: 'Toronto', country: 'Canada' },
  { code: 'YVR', city: 'Vancouver', country: 'Canada' },
  { code: 'YMQ', city: 'Montreal', country: 'Canada' },
  { code: 'YYC', city: 'Calgary', country: 'Canada' },
  { code: 'YEG', city: 'Edmonton', country: 'Canada' },
  { code: 'YOW', city: 'Ottawa', country: 'Canada' },
  { code: 'YWG', city: 'Winnipeg', country: 'Canada' },
  { code: 'YHZ', city: 'Halifax', country: 'Canada' },
  { code: 'YQB', city: 'Quebec City', country: 'Canada' },
  { code: 'YYJ', city: 'Victoria', country: 'Canada' },

  // Mexico & Central America
  { code: 'MEX', city: 'Mexico City', country: 'Mexico' },
  { code: 'CUN', city: 'Cancun', country: 'Mexico' },
  { code: 'GDL', city: 'Guadalajara', country: 'Mexico' },
  { code: 'MTY', city: 'Monterrey', country: 'Mexico' },
  { code: 'PVR', city: 'Puerto Vallarta', country: 'Mexico' },
  { code: 'CZM', city: 'Cozumel', country: 'Mexico' },
  { code: 'SJD', city: 'Los Cabos', country: 'Mexico' },
  { code: 'TIJ', city: 'Tijuana', country: 'Mexico' },
  { code: 'MZT', city: 'Mazatlán', country: 'Mexico' },
  { code: 'OAX', city: 'Oaxaca', country: 'Mexico' },
  { code: 'SJO', city: 'San José', country: 'Costa Rica' },
  { code: 'PTY', city: 'Panama City', country: 'Panama' },
  { code: 'GUA', city: 'Guatemala City', country: 'Guatemala' },
  { code: 'SAL', city: 'San Salvador', country: 'El Salvador' },
  { code: 'TGU', city: 'Tegucigalpa', country: 'Honduras' },
  { code: 'MGA', city: 'Managua', country: 'Nicaragua' },
  { code: 'BZE', city: 'Belize City', country: 'Belize' },

  // Caribbean
  { code: 'HAV', city: 'Havana', country: 'Cuba' },
  { code: 'SJU', city: 'San Juan', country: 'Puerto Rico' },
  { code: 'SDQ', city: 'Santo Domingo', country: 'Dominican Republic' },
  { code: 'PUJ', city: 'Punta Cana', country: 'Dominican Republic' },
  { code: 'KIN', city: 'Kingston', country: 'Jamaica' },
  { code: 'MBJ', city: 'Montego Bay', country: 'Jamaica' },
  { code: 'NAS', city: 'Nassau', country: 'Bahamas' },
  { code: 'BGI', city: 'Bridgetown', country: 'Barbados' },
  { code: 'AUA', city: 'Aruba', country: 'Aruba' },
  { code: 'CUR', city: 'Curaçao', country: 'Curaçao' },

  // United Kingdom & Ireland
  { code: 'LON', city: 'London', country: 'UK' },
  { code: 'EDI', city: 'Edinburgh', country: 'UK' },
  { code: 'MAN', city: 'Manchester', country: 'UK' },
  { code: 'BHX', city: 'Birmingham', country: 'UK' },
  { code: 'GLA', city: 'Glasgow', country: 'UK' },
  { code: 'NCL', city: 'Newcastle', country: 'UK' },
  { code: 'LDS', city: 'Leeds', country: 'UK' },
  { code: 'LPL', city: 'Liverpool', country: 'UK' },
  { code: 'BRS', city: 'Bristol', country: 'UK' },
  { code: 'BFS', city: 'Belfast', country: 'UK' },
  { code: 'DUB', city: 'Dublin', country: 'Ireland' },
  { code: 'ORK', city: 'Cork', country: 'Ireland' },
  { code: 'SNN', city: 'Shannon', country: 'Ireland' },

  // France
  { code: 'PAR', city: 'Paris', country: 'France' },
  { code: 'NCE', city: 'Nice', country: 'France' },
  { code: 'LYS', city: 'Lyon', country: 'France' },
  { code: 'MRS', city: 'Marseille', country: 'France' },
  { code: 'TLS', city: 'Toulouse', country: 'France' },
  { code: 'BDX', city: 'Bordeaux', country: 'France' },
  { code: 'NTE', city: 'Nantes', country: 'France' },
  { code: 'SXB', city: 'Strasbourg', country: 'France' },
  { code: 'BOD', city: 'Biarritz', country: 'France' },
  { code: 'MXP', city: 'Cannes', country: 'France' },

  // Germany
  { code: 'BER', city: 'Berlin', country: 'Germany' },
  { code: 'MUC', city: 'Munich', country: 'Germany' },
  { code: 'FRA', city: 'Frankfurt', country: 'Germany' },
  { code: 'HAM', city: 'Hamburg', country: 'Germany' },
  { code: 'DUS', city: 'Düsseldorf', country: 'Germany' },
  { code: 'CGN', city: 'Cologne', country: 'Germany' },
  { code: 'STR', city: 'Stuttgart', country: 'Germany' },
  { code: 'DRS', city: 'Dresden', country: 'Germany' },
  { code: 'LEJ', city: 'Leipzig', country: 'Germany' },
  { code: 'NUE', city: 'Nuremberg', country: 'Germany' },

  // Italy
  { code: 'ROM', city: 'Rome', country: 'Italy' },
  { code: 'MIL', city: 'Milan', country: 'Italy' },
  { code: 'VCE', city: 'Venice', country: 'Italy' },
  { code: 'FLR', city: 'Florence', country: 'Italy' },
  { code: 'NAP', city: 'Naples', country: 'Italy' },
  { code: 'TRN', city: 'Turin', country: 'Italy' },
  { code: 'BLQ', city: 'Bologna', country: 'Italy' },
  { code: 'GOA', city: 'Genoa', country: 'Italy' },
  { code: 'CTA', city: 'Catania', country: 'Italy' },
  { code: 'PMO', city: 'Palermo', country: 'Italy' },
  { code: 'BRI', city: 'Bari', country: 'Italy' },

  // Spain
  { code: 'MAD', city: 'Madrid', country: 'Spain' },
  { code: 'BCN', city: 'Barcelona', country: 'Spain' },
  { code: 'SVQ', city: 'Seville', country: 'Spain' },
  { code: 'VLC', city: 'Valencia', country: 'Spain' },
  { code: 'AGP', city: 'Málaga', country: 'Spain' },
  { code: 'PMI', city: 'Palma de Mallorca', country: 'Spain' },
  { code: 'BIO', city: 'Bilbao', country: 'Spain' },
  { code: 'ALC', city: 'Alicante', country: 'Spain' },
  { code: 'GRX', city: 'Granada', country: 'Spain' },
  { code: 'TCI', city: 'Tenerife', country: 'Spain' },
  { code: 'LPA', city: 'Las Palmas', country: 'Spain' },
  { code: 'IBZ', city: 'Ibiza', country: 'Spain' },

  // Portugal
  { code: 'LIS', city: 'Lisbon', country: 'Portugal' },
  { code: 'OPO', city: 'Porto', country: 'Portugal' },
  { code: 'FAO', city: 'Faro', country: 'Portugal' },
  { code: 'FNC', city: 'Funchal', country: 'Portugal' },
  { code: 'PDL', city: 'Azores', country: 'Portugal' },

  // Netherlands, Belgium & Luxembourg
  { code: 'AMS', city: 'Amsterdam', country: 'Netherlands' },
  { code: 'RTM', city: 'Rotterdam', country: 'Netherlands' },
  { code: 'EIN', city: 'Eindhoven', country: 'Netherlands' },
  { code: 'BRU', city: 'Brussels', country: 'Belgium' },
  { code: 'ANR', city: 'Antwerp', country: 'Belgium' },
  { code: 'CRL', city: 'Charleroi', country: 'Belgium' },
  { code: 'LUX', city: 'Luxembourg', country: 'Luxembourg' },

  // Switzerland & Austria
  { code: 'ZRH', city: 'Zurich', country: 'Switzerland' },
  { code: 'GVA', city: 'Geneva', country: 'Switzerland' },
  { code: 'BSL', city: 'Basel', country: 'Switzerland' },
  { code: 'BRN', city: 'Bern', country: 'Switzerland' },
  { code: 'VIE', city: 'Vienna', country: 'Austria' },
  { code: 'SZG', city: 'Salzburg', country: 'Austria' },
  { code: 'INN', city: 'Innsbruck', country: 'Austria' },

  // Scandinavia
  { code: 'STO', city: 'Stockholm', country: 'Sweden' },
  { code: 'GOT', city: 'Gothenburg', country: 'Sweden' },
  { code: 'MMX', city: 'Malmö', country: 'Sweden' },
  { code: 'CPH', city: 'Copenhagen', country: 'Denmark' },
  { code: 'OSL', city: 'Oslo', country: 'Norway' },
  { code: 'BGO', city: 'Bergen', country: 'Norway' },
  { code: 'TRD', city: 'Trondheim', country: 'Norway' },
  { code: 'HEL', city: 'Helsinki', country: 'Finland' },
  { code: 'REK', city: 'Reykjavik', country: 'Iceland' },

  // Eastern Europe
  { code: 'PRG', city: 'Prague', country: 'Czech Republic' },
  { code: 'BUD', city: 'Budapest', country: 'Hungary' },
  { code: 'WAW', city: 'Warsaw', country: 'Poland' },
  { code: 'KRK', city: 'Krakow', country: 'Poland' },
  { code: 'BUH', city: 'Bucharest', country: 'Romania' },
  { code: 'SOF', city: 'Sofia', country: 'Bulgaria' },
  { code: 'BEG', city: 'Belgrade', country: 'Serbia' },
  { code: 'ZAG', city: 'Zagreb', country: 'Croatia' },
  { code: 'SPU', city: 'Split', country: 'Croatia' },
  { code: 'DBV', city: 'Dubrovnik', country: 'Croatia' },
  { code: 'BTS', city: 'Bratislava', country: 'Slovakia' },
  { code: 'LJU', city: 'Ljubljana', country: 'Slovenia' },
  { code: 'TLL', city: 'Tallinn', country: 'Estonia' },
  { code: 'RIX', city: 'Riga', country: 'Latvia' },
  { code: 'VNO', city: 'Vilnius', country: 'Lithuania' },

  // Greece & Cyprus
  { code: 'ATH', city: 'Athens', country: 'Greece' },
  { code: 'SKG', city: 'Thessaloniki', country: 'Greece' },
  { code: 'HER', city: 'Heraklion', country: 'Greece' },
  { code: 'RHO', city: 'Rhodes', country: 'Greece' },
  { code: 'CFU', city: 'Corfu', country: 'Greece' },
  { code: 'JTR', city: 'Santorini', country: 'Greece' },
  { code: 'ZTH', city: 'Zakynthos', country: 'Greece' },
  { code: 'LCA', city: 'Larnaca', country: 'Cyprus' },
  { code: 'PFO', city: 'Paphos', country: 'Cyprus' },

  // Turkey
  { code: 'IST', city: 'Istanbul', country: 'Turkey' },
  { code: 'ANK', city: 'Ankara', country: 'Turkey' },
  { code: 'AYT', city: 'Antalya', country: 'Turkey' },
  { code: 'IZM', city: 'Izmir', country: 'Turkey' },
  { code: 'BOD', city: 'Bodrum', country: 'Turkey' },
  { code: 'DLM', city: 'Dalaman', country: 'Turkey' },

  // Russia & CIS
  { code: 'MOW', city: 'Moscow', country: 'Russia' },
  { code: 'LED', city: 'St. Petersburg', country: 'Russia' },
  { code: 'SVX', city: 'Yekaterinburg', country: 'Russia' },
  { code: 'KZN', city: 'Kazan', country: 'Russia' },
  { code: 'KIV', city: 'Chisinau', country: 'Moldova' },
  { code: 'KBP', city: 'Kyiv', country: 'Ukraine' },
  { code: 'MSQ', city: 'Minsk', country: 'Belarus' },

  // Middle East
  { code: 'DXB', city: 'Dubai', country: 'UAE' },
  { code: 'AUH', city: 'Abu Dhabi', country: 'UAE' },
  { code: 'SHJ', city: 'Sharjah', country: 'UAE' },
  { code: 'DOH', city: 'Doha', country: 'Qatar' },
  { code: 'BAH', city: 'Bahrain', country: 'Bahrain' },
  { code: 'KWI', city: 'Kuwait City', country: 'Kuwait' },
  { code: 'MCT', city: 'Muscat', country: 'Oman' },
  { code: 'RUH', city: 'Riyadh', country: 'Saudi Arabia' },
  { code: 'JED', city: 'Jeddah', country: 'Saudi Arabia' },
  { code: 'DMM', city: 'Dammam', country: 'Saudi Arabia' },
  { code: 'TLV', city: 'Tel Aviv', country: 'Israel' },
  { code: 'AMM', city: 'Amman', country: 'Jordan' },
  { code: 'BEY', city: 'Beirut', country: 'Lebanon' },

  // North Africa
  { code: 'CAI', city: 'Cairo', country: 'Egypt' },
  { code: 'SSH', city: 'Sharm el-Sheikh', country: 'Egypt' },
  { code: 'HRG', city: 'Hurghada', country: 'Egypt' },
  { code: 'LXR', city: 'Luxor', country: 'Egypt' },
  { code: 'CAS', city: 'Casablanca', country: 'Morocco' },
  { code: 'MAR', city: 'Marrakech', country: 'Morocco' },
  { code: 'RAK', city: 'Rabat', country: 'Morocco' },
  { code: 'FEZ', city: 'Fez', country: 'Morocco' },
  { code: 'TUN', city: 'Tunis', country: 'Tunisia' },
  { code: 'ALG', city: 'Algiers', country: 'Algeria' },
  { code: 'TIP', city: 'Tripoli', country: 'Libya' },

  // Sub-Saharan Africa
  { code: 'JNB', city: 'Johannesburg', country: 'South Africa' },
  { code: 'CPT', city: 'Cape Town', country: 'South Africa' },
  { code: 'DUR', city: 'Durban', country: 'South Africa' },
  { code: 'PLZ', city: 'Port Elizabeth', country: 'South Africa' },
  { code: 'NBO', city: 'Nairobi', country: 'Kenya' },
  { code: 'MBA', city: 'Mombasa', country: 'Kenya' },
  { code: 'DAR', city: 'Dar es Salaam', country: 'Tanzania' },
  { code: 'ZNZ', city: 'Zanzibar', country: 'Tanzania' },
  { code: 'KGL', city: 'Kigali', country: 'Rwanda' },
  { code: 'EBB', city: 'Entebbe', country: 'Uganda' },
  { code: 'ADD', city: 'Addis Ababa', country: 'Ethiopia' },
  { code: 'ACC', city: 'Accra', country: 'Ghana' },
  { code: 'LOS', city: 'Lagos', country: 'Nigeria' },
  { code: 'ABV', city: 'Abuja', country: 'Nigeria' },
  { code: 'DKR', city: 'Dakar', country: 'Senegal' },
  { code: 'ABJ', city: 'Abidjan', country: 'Ivory Coast' },
  { code: 'MRU', city: 'Mauritius', country: 'Mauritius' },
  { code: 'SEZ', city: 'Seychelles', country: 'Seychelles' },
  { code: 'LUN', city: 'Lusaka', country: 'Zambia' },
  { code: 'HRE', city: 'Harare', country: 'Zimbabwe' },
  { code: 'WDH', city: 'Windhoek', country: 'Namibia' },
  { code: 'GBE', city: 'Gaborone', country: 'Botswana' },

  // China
  { code: 'BJS', city: 'Beijing', country: 'China' },
  { code: 'SHA', city: 'Shanghai', country: 'China' },
  { code: 'CAN', city: 'Guangzhou', country: 'China' },
  { code: 'SZX', city: 'Shenzhen', country: 'China' },
  { code: 'CTU', city: 'Chengdu', country: 'China' },
  { code: 'XIY', city: "Xi'an", country: 'China' },
  { code: 'HGH', city: 'Hangzhou', country: 'China' },
  { code: 'NKG', city: 'Nanjing', country: 'China' },
  { code: 'WUH', city: 'Wuhan', country: 'China' },
  { code: 'CGQ', city: 'Changchun', country: 'China' },
  { code: 'DLC', city: 'Dalian', country: 'China' },
  { code: 'TSN', city: 'Tianjin', country: 'China' },
  { code: 'KMG', city: 'Kunming', country: 'China' },

  // Japan
  { code: 'TYO', city: 'Tokyo', country: 'Japan' },
  { code: 'OSA', city: 'Osaka', country: 'Japan' },
  { code: 'NGO', city: 'Nagoya', country: 'Japan' },
  { code: 'SPK', city: 'Sapporo', country: 'Japan' },
  { code: 'FUK', city: 'Fukuoka', country: 'Japan' },
  { code: 'OKA', city: 'Okinawa', country: 'Japan' },
  { code: 'KIX', city: 'Kyoto', country: 'Japan' },
  { code: 'HIJ', city: 'Hiroshima', country: 'Japan' },

  // South Korea
  { code: 'SEL', city: 'Seoul', country: 'South Korea' },
  { code: 'PUS', city: 'Busan', country: 'South Korea' },
  { code: 'CJU', city: 'Jeju', country: 'South Korea' },
  { code: 'ICN', city: 'Incheon', country: 'South Korea' },

  // Southeast Asia - Thailand
  { code: 'BKK', city: 'Bangkok', country: 'Thailand' },
  { code: 'HKT', city: 'Phuket', country: 'Thailand' },
  { code: 'CNX', city: 'Chiang Mai', country: 'Thailand' },
  { code: 'USM', city: 'Koh Samui', country: 'Thailand' },
  { code: 'KBV', city: 'Krabi', country: 'Thailand' },
  { code: 'HDY', city: 'Hat Yai', country: 'Thailand' },

  // Vietnam
  { code: 'HAN', city: 'Hanoi', country: 'Vietnam' },
  { code: 'SGN', city: 'Ho Chi Minh City', country: 'Vietnam' },
  { code: 'DAD', city: 'Da Nang', country: 'Vietnam' },
  { code: 'NHA', city: 'Nha Trang', country: 'Vietnam' },
  { code: 'PQC', city: 'Phu Quoc', country: 'Vietnam' },

  // Indonesia
  { code: 'JKT', city: 'Jakarta', country: 'Indonesia' },
  { code: 'DPS', city: 'Bali', country: 'Indonesia' },
  { code: 'SUB', city: 'Surabaya', country: 'Indonesia' },
  { code: 'CGK', city: 'Tangerang', country: 'Indonesia' },
  { code: 'LOP', city: 'Lombok', country: 'Indonesia' },

  // Malaysia
  { code: 'KUL', city: 'Kuala Lumpur', country: 'Malaysia' },
  { code: 'PEN', city: 'Penang', country: 'Malaysia' },
  { code: 'JHB', city: 'Johor Bahru', country: 'Malaysia' },
  { code: 'KCH', city: 'Kuching', country: 'Malaysia' },
  { code: 'LGK', city: 'Langkawi', country: 'Malaysia' },

  // Singapore, Philippines & Others
  { code: 'SIN', city: 'Singapore', country: 'Singapore' },
  { code: 'MNL', city: 'Manila', country: 'Philippines' },
  { code: 'CEB', city: 'Cebu', country: 'Philippines' },
  { code: 'BKI', city: 'Kota Kinabalu', country: 'Malaysia' },
  { code: 'RGN', city: 'Yangon', country: 'Myanmar' },
  { code: 'VTE', city: 'Vientiane', country: 'Laos' },
  { code: 'REP', city: 'Siem Reap', country: 'Cambodia' },
  { code: 'PNH', city: 'Phnom Penh', country: 'Cambodia' },
  { code: 'BWN', city: 'Bandar Seri Begawan', country: 'Brunei' },

  // Hong Kong, Macau & Taiwan
  { code: 'HKG', city: 'Hong Kong', country: 'Hong Kong' },
  { code: 'MFM', city: 'Macau', country: 'Macau' },
  { code: 'TPE', city: 'Taipei', country: 'Taiwan' },
  { code: 'KHH', city: 'Kaohsiung', country: 'Taiwan' },
  { code: 'RMQ', city: 'Taichung', country: 'Taiwan' },

  // India
  { code: 'DEL', city: 'Delhi', country: 'India' },
  { code: 'BOM', city: 'Mumbai', country: 'India' },
  { code: 'BLR', city: 'Bangalore', country: 'India' },
  { code: 'MAA', city: 'Chennai', country: 'India' },
  { code: 'HYD', city: 'Hyderabad', country: 'India' },
  { code: 'CCU', city: 'Kolkata', country: 'India' },
  { code: 'GOI', city: 'Goa', country: 'India' },
  { code: 'JAI', city: 'Jaipur', country: 'India' },
  { code: 'AMD', city: 'Ahmedabad', country: 'India' },
  { code: 'PNQ', city: 'Pune', country: 'India' },
  { code: 'COK', city: 'Kochi', country: 'India' },
  { code: 'TRV', city: 'Trivandrum', country: 'India' },

  // Pakistan, Bangladesh, Sri Lanka & Nepal
  { code: 'KHI', city: 'Karachi', country: 'Pakistan' },
  { code: 'LHE', city: 'Lahore', country: 'Pakistan' },
  { code: 'ISB', city: 'Islamabad', country: 'Pakistan' },
  { code: 'DAC', city: 'Dhaka', country: 'Bangladesh' },
  { code: 'CMB', city: 'Colombo', country: 'Sri Lanka' },
  { code: 'KTM', city: 'Kathmandu', country: 'Nepal' },
  { code: 'MLE', city: 'Malé', country: 'Maldives' },

  // Australia
  { code: 'SYD', city: 'Sydney', country: 'Australia' },
  { code: 'MEL', city: 'Melbourne', country: 'Australia' },
  { code: 'BNE', city: 'Brisbane', country: 'Australia' },
  { code: 'PER', city: 'Perth', country: 'Australia' },
  { code: 'ADL', city: 'Adelaide', country: 'Australia' },
  { code: 'OOL', city: 'Gold Coast', country: 'Australia' },
  { code: 'CNS', city: 'Cairns', country: 'Australia' },
  { code: 'DRW', city: 'Darwin', country: 'Australia' },
  { code: 'HBA', city: 'Hobart', country: 'Australia' },
  { code: 'CBR', city: 'Canberra', country: 'Australia' },

  // New Zealand
  { code: 'AKL', city: 'Auckland', country: 'New Zealand' },
  { code: 'WLG', city: 'Wellington', country: 'New Zealand' },
  { code: 'CHC', city: 'Christchurch', country: 'New Zealand' },
  { code: 'ZQN', city: 'Queenstown', country: 'New Zealand' },
  { code: 'ROT', city: 'Rotorua', country: 'New Zealand' },

  // Pacific Islands
  { code: 'NAN', city: 'Nadi', country: 'Fiji' },
  { code: 'PPT', city: 'Papeete', country: 'French Polynesia' },
  { code: 'NOU', city: 'Nouméa', country: 'New Caledonia' },
  { code: 'VLI', city: 'Port Vila', country: 'Vanuatu' },
  { code: 'APW', city: 'Apia', country: 'Samoa' },
  { code: 'TBU', city: 'Nuku\'alofa', country: 'Tonga' },
  { code: 'RAR', city: 'Rarotonga', country: 'Cook Islands' },
  { code: 'GUM', city: 'Guam', country: 'Guam' },

  // South America
  { code: 'SAO', city: 'São Paulo', country: 'Brazil' },
  { code: 'RIO', city: 'Rio de Janeiro', country: 'Brazil' },
  { code: 'BSB', city: 'Brasília', country: 'Brazil' },
  { code: 'SSA', city: 'Salvador', country: 'Brazil' },
  { code: 'FOR', city: 'Fortaleza', country: 'Brazil' },
  { code: 'REC', city: 'Recife', country: 'Brazil' },
  { code: 'CWB', city: 'Curitiba', country: 'Brazil' },
  { code: 'POA', city: 'Porto Alegre', country: 'Brazil' },
  { code: 'MCP', city: 'Macapá', country: 'Brazil' },
  { code: 'MAO', city: 'Manaus', country: 'Brazil' },
  { code: 'BUE', city: 'Buenos Aires', country: 'Argentina' },
  { code: 'COR', city: 'Córdoba', country: 'Argentina' },
  { code: 'MDZ', city: 'Mendoza', country: 'Argentina' },
  { code: 'SCL', city: 'Santiago', country: 'Chile' },
  { code: 'LIM', city: 'Lima', country: 'Peru' },
  { code: 'CUZ', city: 'Cusco', country: 'Peru' },
  { code: 'BOG', city: 'Bogotá', country: 'Colombia' },
  { code: 'MDE', city: 'Medellín', country: 'Colombia' },
  { code: 'CTG', city: 'Cartagena', country: 'Colombia' },
  { code: 'UIO', city: 'Quito', country: 'Ecuador' },
  { code: 'GYE', city: 'Guayaquil', country: 'Ecuador' },
  { code: 'CCS', city: 'Caracas', country: 'Venezuela' },
  { code: 'ASU', city: 'Asunción', country: 'Paraguay' },
  { code: 'MVD', city: 'Montevideo', country: 'Uruguay' },
  { code: 'LPB', city: 'La Paz', country: 'Bolivia' },
  { code: 'GEO', city: 'Georgetown', country: 'Guyana' },
  { code: 'PBM', city: 'Paramaribo', country: 'Suriname' },
  { code: 'CAY', city: 'Cayenne', country: 'French Guiana' }
];
